"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const t=require("../todo-list.types.js"),e=o=>o===t.Status.DONE||o===t.Status.IGNORED||o===t.Status.RECALLED;exports.isTodoDone=e;
